import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2f976bf2 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _5548eb40 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _62ff7176 = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _bd1004c8 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _0ea93c9e = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _013e2cf5 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _63f67e7e = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _0653f918 = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _a2bba0c2 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _c132a5d6 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _5102e8a1 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _509a3cfa = () => interopDefault(import('../../../pages/homeowner-dashboard/index.vue' /* webpackChunkName: "pages/homeowner-dashboard/index" */))
const _7567c1ad = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _603f5c63 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _555406b0 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _4b965e5a = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _0d867983 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _aa87f252 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _3f6382ef = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _40d2d4b1 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _5719e897 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _3f1341e4 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _a60fadca = () => interopDefault(import('../../../pages/photo-booking-confirmation/index.vue' /* webpackChunkName: "pages/photo-booking-confirmation/index" */))
const _56e20d07 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _69a1883e = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _a4f9ee2c = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _2569e6ff = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _2c053cbe = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _320f1c42 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _01bb9e35 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _112ff14f = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _9b3ff87c = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _7e23fc88 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _5397bef2 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _83748e02 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _e334c02c = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _1a5a1909 = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _5767408c = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _cedb476a = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _15ddee76 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _077cb0f4 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _b1222a64 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _0cd1a168 = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _5aafcfc5 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _1509e036 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _4002e3fb = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _b86f7bf2 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _77699672 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _afdc32b8 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _6a864527 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _e3b7875c = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _42948577 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _cccc1326 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _a97d98c8 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _5c0477c0 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _8c8a7278 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _0e906ee8 = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _94cd758e = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _10921591 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _c9553c7a = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _2043fbda = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _a0fb0f88 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _81b1de22 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _0fd0012d = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _64b0172c = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _05e9ab1f = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _604cabf9 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _d0dd125e = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _30366e52 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _44056cee = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _13a54bde = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _021a23d0 = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _80feada6 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _734cd85d = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _7b5de856 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _173fd9a2 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _aaca2cd8 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _1a0bf0b9 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _3daada64 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _2f976bf2,
    name: "404-error"
  }, {
    path: "/app",
    component: _5548eb40,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _62ff7176,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _bd1004c8,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _0ea93c9e,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _013e2cf5,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _63f67e7e,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _0653f918,
    name: "comparables"
  }, {
    path: "/contact",
    component: _a2bba0c2,
    name: "contact"
  }, {
    path: "/faq",
    component: _c132a5d6,
    name: "faq"
  }, {
    path: "/favourites",
    component: _5102e8a1,
    name: "favourites"
  }, {
    path: "/homeowner-dashboard",
    component: _509a3cfa,
    name: "homeowner-dashboard"
  }, {
    path: "/list-home",
    component: _7567c1ad,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _603f5c63,
    name: "listing-management"
  }, {
    path: "/login",
    component: _555406b0,
    name: "login"
  }, {
    path: "/market-data",
    component: _4b965e5a,
    name: "market-data"
  }, {
    path: "/messages",
    component: _0d867983,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _aa87f252,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _3f6382ef,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _40d2d4b1,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _5719e897,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _3f1341e4,
    name: "offers"
  }, {
    path: "/photo-booking-confirmation",
    component: _a60fadca,
    name: "photo-booking-confirmation"
  }, {
    path: "/privacy",
    component: _56e20d07,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _69a1883e,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _a4f9ee2c,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _2569e6ff,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _2c053cbe,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _320f1c42,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _01bb9e35,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _112ff14f,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _9b3ff87c,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _7e23fc88,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _5397bef2,
    name: "users"
  }, {
    path: "/whoweare",
    component: _83748e02,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _e334c02c,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _1a5a1909,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _5767408c,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _cedb476a,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _15ddee76,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _077cb0f4,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _b1222a64,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _0cd1a168,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _5aafcfc5,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _1509e036,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _4002e3fb,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _b86f7bf2,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _77699672,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _afdc32b8,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _6a864527,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _e3b7875c,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _42948577,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _cccc1326,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _a97d98c8,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _5c0477c0,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _8c8a7278,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _0e906ee8,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _94cd758e,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _10921591,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _c9553c7a,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _2043fbda,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _a0fb0f88,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _81b1de22,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _0fd0012d,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _64b0172c,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _05e9ab1f,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _604cabf9,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _d0dd125e,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _30366e52,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _44056cee,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _13a54bde,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _021a23d0,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _80feada6,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _734cd85d,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _7b5de856,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _173fd9a2,
    name: "listings-id-submit-success"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _aaca2cd8,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _1a0bf0b9,
    name: "users-id-section"
  }, {
    path: "/",
    component: _3daada64,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/user/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
